import { useTranslation } from 'react-i18next'

import { CrownIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { SegmentedControls, Text } from '@reveni-io/reveni-ui'

import { editorModeDescriptions, editorModes } from './constants'
import * as Styles from './styles'

const EditorModeSelector = ({ mode, onChangeMode, smartTrackingEnabled, isCustomHtmlUpsellShown, disabled }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const isCustomHtmlLocked = !smartTrackingEnabled

  const options = [
    { id: editorModes.html, label: t('Estándar'), disabled },
    {
      id: editorModes.liquid,
      label: t('HTML personalizado'),
      disabled,
      Icon: isCustomHtmlLocked ? CrownIcon : undefined,
    },
  ]

  return (
    <Styles.Container>
      <Styles.TitleContainer>
        <Text type="titleM">{t('Contenido del email')}</Text>
        <Text type="bodyMRegular" color={theme.colors.text.muted}>
          {isCustomHtmlUpsellShown
            ? t('Usa tu propio HTML para diseñar este email. Disponible con Smart Tracking.')
            : t(editorModeDescriptions[mode])}
        </Text>
      </Styles.TitleContainer>
      <Styles.SelectorContainer>
        <SegmentedControls options={options} value={mode} onChange={onChangeMode} />
      </Styles.SelectorContainer>
    </Styles.Container>
  )
}

export default EditorModeSelector
